import type {CommonProps} from './types';

const RightChevronMedium = ({
  color = 'currentColor',
  size = 24,
  ...rest
}: CommonProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={size}
    width={size}
    {...rest}
  >
    <path
      d="M20.25 8.25v-3a1.5 1.5 0 0 0-1.5-1.5h-4"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.25 3.75h-4a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h6"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.42 4.74a.75.75 0 0 1-.71.5H7.29a.75.75 0 0 1-.71-.5l-1-3a.75.75 0 0 1 .71-1h8.42a.75.75 0 0 1 .71 1Z"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <rect
      x="11.25"
      y="11.25"
      width="12"
      height="12"
      rx="1.5"
      ry="1.5"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.25 14.25h6"
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.25 17.25h6"
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.25 20.25h2.25"
    />
  </svg>
);

export default RightChevronMedium;
